import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { fetchUndo } from '../service/dimensionService'
import { UndoRequestResponse } from '../types/Dimension'
import dimensionQueryKeys from './dimensionQueryKeys'

type UseUndoOptionsProps<Entity, TData = UndoRequestResponse<Entity>[]> = {
  companyId: string
  select?: (data: UndoRequestResponse<Entity>[]) => TData
}

export const useUndoOptions = <Entity, TData = UndoRequestResponse<Entity>[]>({
  companyId,
  select
}: UseUndoOptionsProps<Entity, TData>) => {
  return queryOptions({
    queryKey: dimensionQueryKeys.undo({ companyId }),
    queryFn: fetchUndo,
    gcTime: 15 * 60 * 1000,
    enabled: !!companyId,
    select
  }) as UseQueryOptions<TData>
}
